import LayoutUtils from 'src/utils/layout_utils';
import * as ScreeningQuestions from '../screening_questions';
import * as EditForm from '../edit_form';
import * as TimeForm from '../time_form';
import { initAsyncLinkLoaders } from './async_link_loaders';
import { initRequestDocumentReload } from './request_document_reload';
import { initInlineEditListingAutocomplete } from './listing_autocomplete';
import { refreshDashboardShowing as refreshDashboardShowingModule } from './refresh_dashboard';
import { toggleTopMode as toggleTopModeModule } from './toggle_top_mode';
import { initEditLink as initEditLinkModule } from './edit_link';
import { initDropdownActionLink } from './dropdown_action_link';
import { initPopover } from './popover';
import { initPopoverContentLinks } from './popover_content_links';
import { reloadCurrentPopup as reloadCurrentPopupModule } from './reload_popup';
import { initConfirmManuallyLink, initConfirmManuallyLinks } from './confirm_manually';
import { initHistory } from './history';

/**
 * Showings view popup: orchestrates screening, edit form, time form, popovers, and dashboard refresh.
 */
class ShowingsViewPopup {
  init(containerSelector = 'body') {
    document.querySelectorAll(`${containerSelector} .js-showing-view-popup`).forEach((popup) => {
      initPopover(popup, '.js-view-showing-actions.js-popover-wrap', this._popoverCallbacks());
      initPopover(popup, '.js-view-showing-reschedule.js-popover-wrap', this._popoverCallbacks());
      ScreeningQuestions.initScreeningSection(popup);
      initRequestDocumentReload(popup);
      initAsyncLinkLoaders(popup);
      initConfirmManuallyLinks(popup);
      initHistory(popup);

      popup.querySelectorAll('.js-pet-screening-submit').forEach((button) => {
        ScreeningQuestions.initPetScreening(button);
      });

      popup.querySelectorAll('.js-showing-view-note').forEach((noteWrap) => {
        ScreeningQuestions.initNotesEditor(noteWrap);
      });
      popup.querySelectorAll('.js-showing-view-question').forEach((questionWrap) => {
        ScreeningQuestions.initQuestionEditor(questionWrap);
      });
      popup.querySelectorAll('.js-showing-view-document-agreement').forEach((agreementWrap) => {
        ScreeningQuestions.initDocumentAgreementEditor(agreementWrap);
      });
      popup.querySelectorAll('.js-showing-view-credit-card').forEach((cardWrap) => {
        ScreeningQuestions.initCreditCardEditor(cardWrap);
      });

      popup.querySelectorAll('.js-showing-view-edit-link').forEach((editLink) => {
        this.initEditLink(editLink);
      });
      popup.querySelectorAll('.js-showing-view-time-link').forEach((timeLink) => {
        TimeForm.initTimeLink(timeLink, {
          toggleTopMode: (popup, mode) => this.toggleTopMode(popup, mode)
        });
      });

      popup.querySelectorAll('.js-showing-view-edit-form').forEach((form) => {
        EditForm.initEditForm(form, {
          toggleTopMode: (p, mode) => this.toggleTopMode(p, mode),
          refreshDashboardShowing: (uid, id) => this.refreshDashboardShowing(popup, uid, id),
          refreshLucideIcons: () => this.refreshLucideIcons(),
          onTimeSectionReplaced: (f) => EditForm.initEditTimeSection(f),
          reloadCurrentPopup: (p) => this.reloadCurrentPopup(p)
        });
      });
      popup.querySelectorAll('.js-showing-view-time-form').forEach((form) => {
        TimeForm.initTimeForm(form, {
          toggleTopMode: (p, mode) => this.toggleTopMode(p, mode),
          refreshDashboardShowing: (uid, id) => this.refreshDashboardShowing(popup, uid, id),
          reloadCurrentPopup: (p) => this.reloadCurrentPopup(p)
        });
      });
    });

    this.refreshLucideIcons();
  }

  _popoverCallbacks() {
    return {
      initPopoverContentLinks: () => this._initPopoverContentLinks(),
      initAsyncLinkLoaders,
      refreshLucideIcons: () => this.refreshLucideIcons()
    };
  }

  _initPopoverContentLinks() {
    initPopoverContentLinks({
      initEditLink: (editLink) => this.initEditLink(editLink),
      toggleTopMode: (popup, mode) => this.toggleTopMode(popup, mode),
      initTimeLink: (timeLink, opts) => TimeForm.initTimeLink(timeLink, opts),
      initDropdownActionLink,
      initConfirmManuallyLink
    });
  }

  initEditLink(editLink) {
    initEditLinkModule(editLink, {
      toggleTopMode: (popup, mode) => this.toggleTopMode(popup, mode),
      initInlineEditListingAutocomplete
    });
  }

  toggleTopMode(popup, mode) {
    toggleTopModeModule(popup, mode, {
      initInlineEditListingAutocomplete
    });
  }

  reloadCurrentPopup(popup) {
    reloadCurrentPopupModule(popup, {
      toggleTopMode: (p, mode) => this.toggleTopMode(p, mode),
      init: (selector) => this.init(selector)
    });
  }

  refreshDashboardShowing(popup, showingUid, showingId) {
    refreshDashboardShowingModule(popup, showingUid, showingId);
  }

  refreshLucideIcons() {
    LayoutUtils.refreshIcons();
  }
}

export default ShowingsViewPopup;
